module.exports = __webpack_public_path__ + "static/ilustracao-relatorios-gerenciais-4669c1b360b587508046fe2128911c41.svg";